module.exports = __webpack_public_path__ + "img/mobile scanner stand49.f7fab583.jpg";